<template>
    <v-card  elevation="2" class="container-link">
        <iframe :src="url" width="100%" height="100%" frameBorder="0"></iframe>
    </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters({
            resource: "getCurrentResource"
        }),
        url() {
            return this.resource.link;
        }
    }
};
</script>

<style lang="scss" scoped>

.container-link {
    position: relative;
    // overflow: hidden;
    height: 90%;
    width: 95%;
    margin: auto;

}

</style>
